/**
 * 组件 category（英文枚举）→ 界面与 AI 提示词中的中文分类名。
 * 新增 category 时：在此补充；并在 ObjectListPanel 的 CATEGORY_ICONS 中补图标。
 */
export const COMPONENT_CATEGORY_LABEL_ZH: Record<string, string> = {
  building: '建筑',
  equipment: '设备',
  machining: '机加工设备',
  infrastructure: '设施',
  label: '标注',
  pipe: '管道',
  personnel: '人员物流',
  energy: '能源',
  mushroom: '食用菌设备',
  ceramics: '陶瓷',
  food_water: '食品矿泉水',
  food_factory: '食品加工厂',
}

export function categoryLabelZh(category: string): string {
  return COMPONENT_CATEGORY_LABEL_ZH[category] ?? category
}
